import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import apis from './apis';
import { Empty, Card, CardHeader, Title, CardSection, CardTabs, Tabs  } from '@jd/jmtd';
import './index.less';
import _, { mapValues } from 'lodash';
import Footer from './footer/footer'
import MicroApp from '@/common/jmtd-micro-app';
import { connect } from 'react-redux';
import './yx.css';
import './yx-pro.css';
import './yx-extra.css';
import {mainCardData, mainCardMap} from './config'
import ProviderUserTypeInfo from '@/pages/mvp-panel/participant-data/provider-userType-info';
import ActivityTab from '@/pages/mvp-panel/participant-data/components/activity-tab';
import ActivityDetail from '@/pages/mvp-panel/participant-data/components/activity-detail';

const _BossData = forwardRef((props, ref) => {
  const [mainCard, setMainCard] = useState(1);

  const [subCard, setSubCard] = useState(1);
  const [msCard, setMsCard] = useState(1);
  const subCardData = [
    {
      label: '数据总览',
      value: 1
    }
    // {
    //   label: '综合诊断',
    //   value: 2,
    // },
  ];
  const msCardData = [
    {
      label: '数据总览',
      value: 1
    },
    {
      label: '归因诊断',
      value: 2
    },
  ]

  const mainCardId = mainCardMap.get(mainCard)?.pageId ?? null;
  //活动详情需要的参数
  const [activityDetailParams, setActivityDetailParams] = useState('');
  const [subFilter, setSubFilter] = useState(null);

  const formDisabled = useRef(null);
  formDisabled.current = !!activityDetailParams.planCode;

  const changeActivityDetailParams = (params, subFilter) => {
    document.documentElement.scrollTop = 0;
    if (!params) {
      setActivityDetailParams('');
      setSubFilter(null)
      return;
    }
    const { planCode, planName, activityStartTime, activityEndTime, activityStatus, planPercent } = params;
    setActivityDetailParams({ planCode, planName, activityStartTime, activityEndTime, activityStatus, planPercent });
    setSubFilter(subFilter)
  };

  return (
    <div style={{ background: '#F2F3F5', padding: '16px 0', height: '100%', minHeight: '100vh', minWidth: '1200px' }}>
      <Card>
          <Tabs data={mainCardData} value={mainCard} onChange={setMainCard} type={CardTabs} />
      </Card>
      <Card style={{minHeight: '400px'}}>
        <CardSection>
          {
            mainCard === 1 && <Tabs data={subCardData} value={subCard} onChange={setSubCard} size='small'/>
          }
          {
            mainCard === 3 && <Tabs data={msCardData} value={msCard} onChange={setMsCard} size='small'/>
          }
          {
            mainCard === 1 && subCard === 1 &&
            <MicroApp
              pre
              pageId="2569"
            ></MicroApp>
          }
          {
            mainCard === 3 && msCard === 1 &&
            <MicroApp
              pre
              pageId="2380"
            ></MicroApp>
          }
          {
            mainCard === 3 && msCard === 2 &&
            <MicroApp
              pre
              pageId="3476"
            ></MicroApp>
          }
          {
            mainCard === 1 && subCard === 2 &&
            <MicroApp
              // src="//storage.360buyimg.com/sz-page-service/build/2607-channel_analysis-38.0.0.js"
              pre
              pageId="2607"
            ></MicroApp>
            // <Empty className='big-boss-empty' description='研发小姐姐正在飞速敲代码，敬请期待' />
          }
          {
            mainCard === 14 &&
            <React.Fragment>
              {!formDisabled.current && (
                <ProviderUserTypeInfo.Provider>
                  <ActivityTab gotoDetail={changeActivityDetailParams} />
                </ProviderUserTypeInfo.Provider>
              )}
              {formDisabled.current && (
                <ProviderUserTypeInfo.Provider value={subFilter}>
                  <ActivityDetail {...activityDetailParams} gotoAllActivity={changeActivityDetailParams} />
                </ProviderUserTypeInfo.Provider>
              )}
            </React.Fragment>
          }
          {
            mainCard !== 1 && mainCard !== 3 && mainCard!= 14 &&
            <MicroApp pre pageId={mainCardId}>
            </MicroApp>
          }

        </CardSection>
      </Card>
      <Card><Footer/></Card>
    </div>
  );
});

const BossData = connect((state) => {
  if (!state.userInfo.userMap || !state.userInfo.userMap.erp) return {};
  return {
    erp: state.userInfo.userMap.erp,
  };
},null,null,{ forwardRef: true })(_BossData);

export default BossData;

